import {Openings} from "./Openings";
import {Button, DialogActions, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import useWindowSize from "react-use/lib/useWindowSize";
import {Div10} from "./Div10";
import {LogisticsTab} from "./Logistics";

export function NonStockingAvailableModal(props: {
    releaseId: number;
    tab: LogisticsTab;
    onClose(): void;
}) {

    const dim = useWindowSize();

    return (
        <Dialog2 open onClose={props.onClose} maxWidth="xl" fullWidth>
            <DialogTitle>
                Non-Stocking Inventory Available
            </DialogTitle>
            <div style={{height: dim.height * 0.8, display: "flex", flexDirection: "column"}}>
                {props.tab === "div10" ?
                    <Div10 view="default" nonStockingForRelease={props.releaseId} /> :
                    <Openings
                        view="default"
                        type={props.tab === "damaged" || props.tab === "waste" ? "hardware" : props.tab}
                        nonStockingForRelease={props.releaseId}
                    />}
            </div>
            <DialogActions>
                <Button variant="contained" onClick={() => props.onClose()}>Close</Button>
            </DialogActions>
        </Dialog2>
    )
}
